// extracted by mini-css-extract-plugin
export default {"logo":"ServicePage_logo__nf6f-"};